import { useRef, useState } from "react";
import api, { apiError, resolveImg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Upload, Link2, X, Loader2, ImageIcon } from "lucide-react";

export function ImageUploader({ value, onChange, className = "" }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [urlInput, setUrlInput] = useState("");

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Görsel yüklendi");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const applyUrl = () => {
    if (urlInput.trim()) { onChange(urlInput.trim()); setUrlInput(""); }
  };

  return (
    <div className={className}>
      <div className="flex items-start gap-4">
        <div className="w-24 h-24 rounded-md border border-slate-200 bg-gray-50 flex items-center justify-center overflow-hidden shrink-0">
          {value ? (
            <img src={resolveImg(value)} alt="" className="w-full h-full object-cover" data-testid="uploader-preview" />
          ) : (
            <ImageIcon className="w-8 h-8 text-gray-300" />
          )}
        </div>
        <div className="flex-1 space-y-2">
          <div className="flex gap-2">
            <input type="file" accept="image/*" ref={fileRef} onChange={upload} className="hidden" data-testid="uploader-file-input" />
            <Button type="button" variant="outline" size="sm" onClick={() => fileRef.current?.click()} disabled={uploading} data-testid="uploader-upload-btn">
              {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Upload className="w-4 h-4 mr-2" />Bilgisayardan Yükle</>}
            </Button>
            {value && (
              <Button type="button" variant="ghost" size="sm" className="text-rose-600" onClick={() => onChange("")} data-testid="uploader-clear-btn">
                <X className="w-4 h-4" />
              </Button>
            )}
          </div>
          <div className="flex gap-2">
            <div className="relative flex-1">
              <Link2 className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input placeholder="Görsel URL yapıştır" value={urlInput} onChange={(e) => setUrlInput(e.target.value)}
                className="pl-8 h-9" data-testid="uploader-url-input" onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), applyUrl())} />
            </div>
            <Button type="button" variant="outline" size="sm" onClick={applyUrl} data-testid="uploader-url-btn">Ekle</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
